// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:600px){.receiver-channel-mobile-card[data-v-593974f6]{width:calc(100vw - 44px)}}.receiver-channel-mobile-card .channel-list[data-v-593974f6]{height:25px;position:relative;width:25px}.receiver-channel-mobile-card .channel-list .channel[data-v-593974f6]{background-color:#fff;border:1px solid #fff;border-radius:50%;padding:2px;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
